import { useCallback, useMemo } from 'react';
import { useSmsDashboardSocket } from 'infrastructure/hooks/smsDashboard/useSmsDashboardSocket';
import { useSmsDashboardUnreadCount } from 'infrastructure/hooks/smsDashboard/useUnreadConversationsCount';

import type { ISocketData as INewMessageSocketData } from 'infrastructure/hooks/smsDashboard/useNewMessageBroadcast';

interface IProps {
  canLoadCount?: boolean;
}

export const useBadge = ({ canLoadCount }: IProps) => {
  const {
    unreadConversationsCount: { rpm, ccm, rpmUnregistered, ccmUnregistered },
    updateUnreadCountByType,
    updateUnreadCount,
  } = useSmsDashboardUnreadCount({
    canLoad: canLoadCount,
  });
  const unreadValues = [
    rpm.unread,
    ccm.unread,
    rpmUnregistered.unread,
    ccmUnregistered.unread,
  ];

  const hasMessages = useMemo(() => {
    return unreadValues.reduce((a, b) => a + b, 0) > 0;
  }, unreadValues);

  const newMessage = useCallback(
    (data: INewMessageSocketData) => {
      if (canLoadCount && data.message.authorType === 'patient') {
        updateUnreadCountByType(data.type, data.unreadMessageCount);
      }
    },
    [updateUnreadCountByType, canLoadCount],
  );

  const conversationStateChange = useCallback(
    (data: any) => {
      if (canLoadCount) updateUnreadCount(data);
    },
    [updateUnreadCount, canLoadCount],
  );

  useSmsDashboardSocket({
    newMessage,
    conversationStateChange,
  });

  return {
    hasMessages,
  };
};
